<template>
    <section class="section-wrapper section-7-wrapper" :style="sectionStyle">
        <div class="container section-7-container">
          <!--<pre>{{ JSON.stringify(componentData, null, 2) }}</pre>-->
            <!--<pre>{{ JSON.stringify(blockData, null, 2) }}</pre>-->
            <div class="row">
                <div class="col text-center">
                    <a v-if="(componentData.data.link).length>0" class="section-7-section-title-link" :href="componentData.data.link" :target="componentData.data.target==0?'_self':'_blank'">
                        <h1 class="section-wrapper-title section-7-wrapper-title">{{ componentData.data.headline }}</h1>
                    </a>
                    <h1 v-else class="section-wrapper-title section-7-wrapper-title">{{ componentData.data.headline }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 col-12">
                    <div class="section-widget-content section-7-widget-content facebook-widget">
                        <div class="section-7-widget-content-head facebook-widget-head"></div>
                        <div class="widget-content-inner">
                          <div>
                            <div id="fb-root"></div>
                            <!--<div class="fb-page" :data-href="blockData[0][0]['link']" data-tabs="timeline" data-width="500" data-height="500" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/VietnamTourismBoard/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/VietnamTourismBoard/">Vietnam Tourism Board</a></blockquote></div>-->
                            <div class="fb-page" data-href="https://www.facebook.com/VietnamTourismBoard" data-tabs="timeline" data-width="500" data-height="500" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/VietnamTourismBoard" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/VietnamTourismBoard">Vietnam Tourism Board</a></blockquote></div>
                          </div>
                        </div>
                    </div>
                </div>
                <!--
                <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 col-12">
                    <div class="section-7-widget-content-head youtube-widget-head"></div>
                    <div class="section-widget-content section-7-widget-content youtube-widget">
                        
                        <div class="widget-content-inner">
                          <div class="youtube-subscribe">
                              <div class="g-ytsubscribe" data-channelid="UCCWX3wMrxnW5i6VpBnaNOrg" data-layout="full" data-count="default"></div>
                          </div>
                          <div id="youtube-widget-video">
                          </div>
                          <div class="youtube-widget-info">
                              <div class="youtube-widget-video-title" id="youtube-widget-video-title"></div>
                              <div class="youtube-widget-video-desc" id="youtube-widget-video-desc"></div>
                          </div>
                        </div>
                    </div>
                </div>
                -->
                <div v-if="typeof(blockData[2]) == 'object' && (blockData[2]).length>0" class="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 col-12">
                    <div class="section-7-widget-content-head youtube-widget-head"></div>
                    <div class="section-widget-content section-7-widget-content youtube-widget">
                        
                        <div class="widget-content-inner">
                          <div class="youtube-subscribe">
                              <div id="youtube-subscribe-container"></div>
                          </div>
                          <div class="youtube-content-inner-block">
                            <div v-if="blockData[2][0]" id="youtube-widget-video">
                              <div class="video-container">
                                <iframe id="video" width="1920" height="1080" :src="'https://www.youtube.com/embed/'+blockData[2][0]['source']+'?loop=1&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0&amp;controls=0&amp;playlist='+blockData[2][0]['source']" :title="blockData[2][0]['title']" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                              </div>
                            </div>
                            <div v-if="blockData[2][0]" class="youtube-widget-info">
                                <div class="youtube-widget-video-title" id="youtube-widget-video-title">{{blockData[2][0]['title']}}</div>
                                <div class="youtube-widget-video-desc" id="youtube-widget-video-desc" v-html="blockData[2][0]['summary']"></div>
                            </div>
                            <div v-if="typeof(blockData[2]) == 'object' && (blockData[2]).length>1" class="youtube-widget-list">
                              <div v-for="(youtubeItem, index) in blockData[2].slice(1,5)" 
                                :key="index"
                                class="youtube-widget-list-item"
                              >
                                <a v-if="youtubeItem.link" :href="youtubeItem.link" :target="youtubeItem.target">{{youtubeItem.title}}</a>
                                <p v-else>{{youtubeItem.title}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div v-if="typeof(blockData[3]) == 'object' && (blockData[3]).length>0" class="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 col-12">
                    <div class="section-widget-content section-7-widget-content instagram-widget">
                        <div class="section-7-widget-content-head instagram-widget-head"></div>
                        <div class="widget-content-inner">
                          <div class="instagram-widget-container">
                              <!-- eslint-disable vue/no-parsing-error -->
                              <blockquote class="instagram-media" data-instgrm-captioned :data-instgrm-permalink="blockData[3][0]['link']" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/ChBrg-OPgi_/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/p/ChBrg-OPgi_/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">{{blockData[3][0]['title']}}</a></p></div></blockquote> 
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PublicService from "../services/public.service";
import FunctionService from "../services/function.service";
//import BannerItem from "./BannerItemCmp";

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;

import jsonBlock from '/public/assets/data/youtube/data.json';

export default {
  props: ["loggedIn", "componentData"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME,
      id: null,
      title: "",
      type:"",
      code:"",
      posts: [],
      blockData: [],
      youtubeBlock: jsonBlock,
      IGLoaded: 0,
    };
  },
  //async mounted(){
  mounted(){

    this.$nextTick(function(){
      

      let FBScript = document.createElement('script')
      FBScript.setAttribute('src', 'https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v14.0')
      FBScript.setAttribute('crossorigin', 'anonymous')
      FBScript.setAttribute('nonce', '8GPUJpF9')
      FBScript.setAttribute('async', 'true')
      FBScript.setAttribute('defer', 'true')
      document.head.appendChild(FBScript)
    });
      //this.getYoutubeWidget();
      /*
      let IGScript = document.createElement('script')
      IGScript.setAttribute('src', 'https://www.instagram.com/embed.js')
      //IGScript.setAttribute('crossorigin', 'anonymous')
      IGScript.setAttribute('async', 'true')
      IGScript.setAttribute('defer', 'true')
      document.body.appendChild(IGScript)
      */

      console.log('window.instgrm: ');
      //console.table(window);
      let IGScript = document.createElement('script')
      IGScript.setAttribute('src', 'https://www.instagram.com/embed.js')
      //IGScript.setAttribute('crossorigin', 'anonymous')
      IGScript.setAttribute('async', 'true')
      IGScript.setAttribute('defer', 'true')
      document.head.appendChild(IGScript)
      
      var timer = setInterval(function () {
        if(window.instgrm){
          this.IGLoaded = 1;
          if (window.instgrm) {
            window.instgrm.Embeds.process();
          }
        }
        if (this.IGLoaded) {
            clearInterval(timer);
        }
      }, 1000);

      var timer1 = setInterval(function () {
        console.log($('#youtube-subscribe-container').length);
        if($('#youtube-subscribe-container').length>0){
          let youtubeScript = document.createElement('script')
      youtubeScript.setAttribute('src', 'https://apis.google.com/js/platform.js')
      youtubeScript.setAttribute('async', 'true')
      //youtubeScript.setAttribute('defer', 'true')
      document.head.appendChild(youtubeScript)
          $('#youtube-subscribe-container').html('<div class="g-ytsubscribe" data-channelid="UCCWX3wMrxnW5i6VpBnaNOrg" data-layout="full" data-count="default"></div>');
        }
        if($('.g-ytsubscribe').length>0){
          clearInterval(timer1);
        }
      }, 1000);

    /*
    this.$nextTick(function(){
      
    });
    */

  },
  created() {
    var vm = this;
    this.getBlockData(this.componentData, vm);
  },
   watch: {
    blockData() {

    }
  },
  computed: {
    sectionStyle(){   
        let newStyle = {}
        if((this.componentData.data.bgImg).length>0){
          newStyle.backgroundImage = 'url('+this.componentData.data.bgImg+')'
          if((this.componentData.data.bgImgFixed).length>0 && this.componentData.data.bgImgFixed==1){
            newStyle.backgroundAttachment = 'fixed'
          }
        }
        else{
          if((this.componentData.data.bgColor).length>0){
            newStyle.backgroundColor = this.componentData.data.bgColor
          }
        }
        if(this.parentComponentData && typeof(this.parentComponentData.image)=='string' && (this.parentComponentData.image).length==0){
          newStyle.display = 'none';
        }
        return newStyle
    }
  },
  components: {
    //BannerItem
  },
  methods: {
    getBlockData(cfgData, vm) {
      var resp = PublicService.getAllBlockPublicDataByType(cfgData);
      /*
      console.log("resp: ");
      console.log(resp);
      console.log(typeof resp);
      */
      //if(typeof(resp) == 'object' && Object.prototype.hasOwnProperty.call(resp, "data")){
      if (typeof resp == "object") {
        var allData = [];
        
        resp.then(function (data) {
          //console.log(data);
          //alert(data);
          //var dtCt = 0;
          data.forEach((dt) => {
            //console.log(dt.data);
            allData.push(dt.data);
            if(typeof(dt.data.child)=='object'){
                vm.blockData.push(dt.data.child);
              }
              else{
                vm.blockData.push(dt.data);
              }
          });
        });
        //console.log(this.blockData);
      }
    },
    getYoutubeWidget(){
      // Lấy thông tin widget youtube
      $.getJSON('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCCWX3wMrxnW5i6VpBnaNOrg&maxResults=1&order=date&type=video&key=AIzaSyCGuD-Ysg-OmbVP7c0r3I5B3PcvFnROiW4', function(data) {
        var text = '';
        var title = '';
        var desc = '';
        if(typeof(data)=='object'){
            //text = JSON.stringify(data);
            console.log(data.items);
            if(typeof(data.items)=='object'){
                //text += '<div class="image-wrapper"><img src="'+data.items[0].snippet.thumbnails.medium.url+'"/></div>';
                text += '<div class="video-wrapper">\
                    <iframe src="https://www.youtube.com/embed/'+data.items[0].id.videoId+'" height="315" width="560" allowfullscreen="" frameborder="0"></iframe></div>';
                title = data.items[0].snippet.title;
                desc = data.items[0].snippet.description;
            }
        }
        $("#youtube-widget-video").html(text);
        $("#youtube-widget-video-title").html(title);
        $("#youtube-widget-video-desc").html(desc);
      });
    },
    displayPostContent: function (data) {
      return FunctionService.displayPostContent(data);
    },
    removeHTML: function (data) {
      return FunctionService.removeHTML(data);
    },
    displayHtmlContent: function (data) {
      return FunctionService.displayHtmlContent(data);
    },
    getImages: function(str, imgUrl){
      return FunctionService.getImages(str, imgUrl);
    },
    displayEntity: function(str){
      return FunctionService.displayEntity(str);
    },
    shorten: function(str, maxLen, separator = ' '){
      return FunctionService.shorten(str, maxLen, separator);
    },
    genPostLink: function(type, id){
      return FunctionService.genPostLink(type, id);
    },
    genCatLink: function (type, id) {
      return FunctionService.genCatLink(type, id);
    },
    
  },
};

/*
export default {
  props: ["loggedIn"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME
    };
  },
  components: {
    BannerItem
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
*/
</script>

<style>
</style>